
import { defineComponent } from '@vue/runtime-core'
import SidebarBox from './SidebarBox.vue'

export default defineComponent({
  components: { SidebarBox },
    props: ['contentClass', 'headerText', 'headerInfo', 'sectionClass', 'sidebarProps'],
});
